import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-token',
  templateUrl: './reset-password-token.component.html',
  styleUrls: ['./reset-password-token.component.scss']
})
export class ResetPasswordTokenComponent implements OnInit {

  reset_password = {
    password: null,
    token: null,
    confirm_password: null
  };
  constructor() { }

  ngOnInit(): void {
  }

}
